<span class="sui-input__field">
  <input
    #nativeInput
    ngpInput
    [id]="effectiveId"
    [type]="type"
    [placeholder]="placeholder"
    [disabled]="isDisabled()"
    [readOnly]="readonly"
    [attr.min]="min ?? null"
    [attr.max]="max ?? null"
    [attr.step]="step ?? null"
    [attr.autocomplete]="autocomplete || null"
    [attr.aria-invalid]="errorState ? 'true' : null"
    [value]="value() ?? ''"
    (input)="onInput($event)"
    (blur)="markTouched()"
  />
  <!-- Trailing unit/affix (e.g. metricSymbol "px"). Flex item inside the box;
       text styling lives in sui-globals ([sui-suffix]) since it's projected. -->
  <ng-content select="[sui-suffix]"></ng-content>
  <fa-icon
    class="sui-input__invalid-icon"
    [icon]="faCircleExclamation"
    aria-hidden="true"
  ></fa-icon>
</span>
